import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling. Respects prefers-reduced-motion.
export default function SmoothScroll() {
    useEffect(() => {
        const reduce = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (reduce) return;

        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        window.__lenis = lenis;

        // Anchor links -> lenis smooth scroll
        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href").slice(1);
            const el = id ? document.getElementById(id) : null;
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -80 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return null;
}
